import { useState } from "react";
import { ledgerPaid } from "src/print-configuration/PrintConfigration";
import { notifyError, notifySuccess } from "src/assets/toastService";
import { postLedger } from "src/shared/services/servicesv2";
import { LedgerDetails } from "src/shared/services/interfacev2";

export const usePayment = (customerData: LedgerDetails, customerId: string, onClose: () => void, refetchLedger: () => void) => {
  const [paymentLoading, setPaymentLoading] = useState<boolean>(false);
  const [print, setPrintData] = useState<ledgerPaid>();

  const handlePayment = async (amount: string, method: string, discounts: string) => {
    setPaymentLoading(true);

    if (!amount || parseFloat(amount) <= 0) {
      notifyError("Enter a valid amount");
      setPaymentLoading(false);
      return;
    }

    try {
      const currentDate = new Date();

      // Date
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      const day = String(currentDate.getDate()).padStart(2, "0");

      // Time with seconds
      const hours = String(currentDate.getHours()).padStart(2, "0");
      const minutes = String(currentDate.getMinutes()).padStart(2, "0");
      const seconds = String(currentDate.getSeconds()).padStart(2, "0");

      const formattedDate = `${year}-${month}-${day}`;
      const formattedTime = `${hours}:${minutes}:${seconds}`;
      const paidAmount = parseFloat(amount);
      const discount = parseFloat(Number(discounts).toFixed(2)) || 0;

      // Current balance
      // Positive => Outstanding
      // Negative => Advance
      const currentBalance = Number(customerData.totalOutstandingBalance || 0);

      const isAdvance = currentBalance < 0;

      const res = await postLedger({
        customerId: customerId,

        // Store actual balance
        outstandingBalance: currentBalance,

        orderamount: "0",
        payAmount: paidAmount,
        discount: discount,
        paymentMethod: method,

        paidDate: formattedDate,
        paidTime: formattedTime,

        orderDate: formattedDate,
        orderTime: formattedTime,
      });

      let formattedClientId = "0000";

      if (customerData?.customerDetails?.refId) {
        formattedClientId = String(customerData.customerDetails.refId).padStart(4, "0");
      }

      const customerName = [customerData?.customerDetails?.firstName, customerData?.customerDetails?.middleName, customerData?.customerDetails?.lastName]
        .filter((name) => name && name !== "undefined" && name !== "null")
        .join(" ");

      const printData: ledgerPaid = {
        Balance: Math.abs(Number(customerData.totalOutstandingBalance.toFixed(2))),
        Paid: isAdvance ? -Number(paidAmount) : Number(paidAmount),
        PreviousBalance: Math.abs(Number(currentBalance.toFixed(2))),
        previousLabel: isAdvance ? "Prev. Advance(السابق. يتقدم)" : "Prev. Balance(السابق. توازن)",
        paidLabel: isAdvance ? "Refund Amount(مبلغ الاسترداد)" : "Balance Paid(الرصيد المدفوع)",
        balanceLabel: isAdvance ? "Remaining Advance(التقدم المتبقي)" : "New Balance(توازن جديد)",
        isAdvance,
        billNo: res?.data?.billNumber || "",
        clientId: formattedClientId,
        CustomerPhon: Number(customerData.customerDetails?.phones?.[0]?.phone || 0),
        CustomerName: customerName,
        Time: formattedTime,
        Date: formattedDate,
        paymentMethod: method || "",
        discount: discount,
      };

      setPrintData(printData);

      notifySuccess(isAdvance ? "Advance adjusted successfully" : "Payment received successfully");

      setTimeout(() => {
        refetchLedger();
        onClose();
      }, 2000);
    } catch (error) {
      console.error("Payment error:", error);
      notifyError("Payment failed. Try again.");
    } finally {
      setPaymentLoading(false);
    }
  };

  return {
    handlePayment,
    paymentLoading,
    print,
  };
};
